import { Button } from "@egaranti/components";
import { Input } from "@egaranti/components";
import { Label } from "@egaranti/components";
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from "@egaranti/components";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import CategorySelector from "../CategorySelector";

const FilterSheet = ({ open, onOpenChange, onFilterChange, currentFilter }) => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    name: "",
    mainCategoryId: "",
    categoryId: "",
    subCategoryId: "",
    subCategoryBrandId: "",
  });

  useEffect(() => {
    if (open) {
      setFilters({
        name: currentFilter?.name || "",
        mainCategoryId: currentFilter?.mainCategoryId || "",
        categoryId: currentFilter?.categoryId || "",
        subCategoryId: currentFilter?.subCategoryId || "",
        subCategoryBrandId: currentFilter?.subCategoryBrandId || "",
      });
    }
  }, [open, currentFilter]);

  const handleCategoryChange = (categoryValues) => {
    setFilters((prev) => ({
      ...prev,
      ...categoryValues,
    }));
  };

  const onSaveFilter = () => {
    onFilterChange(filters);
    onOpenChange(false);
  };

  const onClearFilters = () => {
    onFilterChange({
      name: "",
      mainCategoryId: "",
      categoryId: "",
      subCategoryId: "",
      subCategoryBrandId: "",
    });
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="m-4 rounded-lg bg-white p-4">
        <SheetHeader>
          <SheetTitle>{t("common.addFilter")}</SheetTitle>
        </SheetHeader>
        <div className="mt-4 flex flex-col gap-4">
          <div>
            <Label>{t("settingsPage.productName")}</Label>
            <Input
              value={filters.name}
              onChange={(e) =>
                setFilters((prev) => ({ ...prev, name: e.target.value }))
              }
            />
          </div>

          <CategorySelector
            value={filters}
            onChange={handleCategoryChange}
            col={1}
          />
        </div>
        <SheetFooter className="mt-4">
          <div className="flex w-full justify-end gap-4">
            <Button variant="secondaryGray" onClick={onClearFilters}>
              {t("common.cancel")}
            </Button>
            <Button onClick={onSaveFilter}>{t("common.save")}</Button>
          </div>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
};

export default FilterSheet;
